<template>
  <div>
    <div v-if="InEmailInputMode">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-base">
          Input your email.
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                    label-placeholder="Email:"
                    v-model="email" />
        </div>
      </div>
      <div>
        <a >Click here to login.</a>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-button @click="SendEmail()">Validate</vs-button>
        </div>
      </div>
    </div>

    <div v-if="InVerificationMode">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-base">
          We have just sent an email with a pin. Please enter it bellow to proceed.
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                    label-placeholder="Code:"
                    v-model="password" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-button @click="ValidatePIN(password)">Validate</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import moment from "vue-moment";

  export default {
    mounted() {
     
    },
    data() {
      return {
        sharedLinks: [],
        password: "",
        email: "",
        InEmailInputMode: true,
        InVerificationMode:false

      }

    },
    methods: {
      SendEmail(password) {
        var instance = this;
        TCVelikClient.PostRelative("/api/share/SendEmailForCompletionVerification?email=" + this.email)
          .then(function (response) {
            if (response && response.status == 200) {
              instance.InVerificationMode = true;
              instance.InEmailInputMode = false;
            }
            else if (response && response.data && response.data.errors) {
              alert('There were some errors loading the shared links');
            }
          });
      },
      ValidatePIN() {
        var instance = this
        TCVelikClient.PostRelative("/api/share/VerifyEmailForCompletion?email=" + instance.email + "&pin=" + instance.password).then(function (response) {
          if (response && response.status == 200) {
            instance.$emit("anon-verified",instance.email)
          }
        }).catch(err => {
          instance.$vs.notify({
            text: "Invalid PIN",
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });

      },
    },
    components: {
      moment
    }
  }
</script>
